export const speedDialAction = {
    cancelCreditRequest: "Cancel Credit Request",
    checkForEdi: "Check for EDI",
    clearReceive: "Clear Receive",
    comments: "Comments",
    finalise: "Finalise",
    forcePartReceive: "Force Part Receive",
    hardwareView: "Hardware View",
    history: "History",
    save: "Save",
    saveDraft: "Save & Exit",
    saveChanges: "Save Changes",
    softwareView: "Software View",
    submitPendingReceive: "Submit Pending Receive",
    submitReview: "Submit",
    viewCredits: "View Credits",
    scrollToTop: "Scroll to Top",
    checkinShipment: "Check in shipment",
    reopenPurchaseOrder: "Reopen PO",
    viewReceive: "View Receive",
} as const;